<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click.stop="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>分配学校 已选 {{selected.length}} 项</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click.stop="save" :loading="saving" :disabled="saving">
          <span class="text-h6">保存</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="4" class="text-body-1 black--text">
            系统：{{appInfo.os | osFilter}}
          </v-col>
          <v-col cols="4" class="text-body-1 black--text">
            版本：{{appInfo.versionName}}
          </v-col>
          <v-col cols="4" class="text-body-1 black--text">
            最小版本：{{appInfo.minVersion}}
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" class="py-5">
            已选：{{selectedName.join('，')}}
          </v-col>
          <v-col cols="12">
            学校列表
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader type="list-item-avatar@10" :loading="loading">
              <v-list shaped >
                <v-list-item-group v-model="selected" multiple>
                  <v-list-item
                    v-for="item in customers"
                    :key="`item-${item.id}`"
                    :value="item.id"
                    active-class="primary--text"
                    :disabled=disabled
                  >
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-action>
                        <v-checkbox :input-value="active" color="primary" @click="toggle"/>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title v-text="item.uniName"/>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'

export default {
  name: 'AppLinkDialog',
  props: {
    status: Boolean,
    appInfo: Object,
    customers: Array
  },
  data () {
    return {
      saving: false,
      loading: true,
      selected: [],
      specific: false,
      disabled: false
    }
  },
  computed: {
    cusMap () {
      return this.customers.reduce((acc, cur) => {
        acc[cur.id] = cur
        return acc
      }, {})
    },
    selectedName () {
      const cl = this.selected.map(cid => this.cusMap[cid])
      cl.sort((a, b) => {
        if (a.extraInfo.pinyin > b.extraInfo.pinyin) {
          return 1
        } else if (a.extraInfo.pinyin < b.extraInfo.pinyin) {
          return -1
        } else {
          return 0
        }
      })
      return cl.map(c => c.uniName)
    }
  },
  created () {
    this.loadSelected()
  },
  methods: {
    loadSelected () {
      this.loading = true
      this.selected = []
      console.log(this.specific)
      console.log(this.disabled)
      this.specific = this.appInfo.specific
      this.disabled = this.specific
      const request = buildAxios()
      request.get('app/getAppLink/' + this.appInfo.id)
        .then(res => {
          const cl = res.data.data
          this.selected = cl.filter(c => c.valid).map(c => c.customerId)
          this.loading = false
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    close () {
      this.$emit('close')
    },
    save () {
      this.saving = true

      const request = buildAxios()
      request.post('app/setLink', {
        appId: this.appInfo.id,
        customerIdSet: this.selected
      })
        .then(res => {
          console.log(res.data.data)
          this.$emit('close')
          this.saving = false
        })
        .catch(reason => {
          this.saving = false
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    }
  },
  filters: {
    osFilter: value => {
      return osList[value]
    }
  },
  watch: {
    status (newVal) {
      if (newVal === true) {
        this.loadSelected()
      }
    }
  }
}

const osList = {
  IOS: 'iOS',
  ANDROID: 'Android',
  OTHER: '其它'
}
</script>
